import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@recruitee/analytics';
import type { TOfferKind } from '@recruitee/offers-types';

@Injectable()
export class EvaluationsAnalytics extends AnalyticsBase {
  public readonly namespace = 'Evaluations';
  public readonly requireViewContext = false;

  public trackRequestEvaluation() {
    this.track('RequestEvaluation');
  }

  public trackEvaluateWithForm(
    trigger: 'addNow' | 'startRequested' | 'hiddenEvaluations',
    isScoreHidden: boolean,
  ) {
    this.track('EvaluateWithForm', { trigger, isScoreHidden });
  }

  public trackFilterEvaluations(filters: {
    type: 'byAssignment' | 'byGroup';
    kind?: TOfferKind;
    groupBy?: string;
  }) {
    const selection = this.getSelection(filters.type, filters?.kind, filters?.groupBy);
    this.track('FilterEvaluations', { type: filters.type, selection });
  }

  private getSelection(type: string, kind?: string, groupBy?: string): string {
    if (type === 'byAssignment') {
      return this.getKind(kind);
    } else {
      return this.getGroup(groupBy);
    }
  }

  private getGroup(group?: string): string {
    switch (group) {
      case 'status':
        return 'noGroup';
      case 'stage':
        return 'stage';
      case 'member':
        return 'teamMember';
      case 'form':
        return 'evaluationForm';
      default:
        return 'stage';
    }
  }

  private getKind(kind?: string): string {
    if (kind === 'job') {
      return 'job';
    } else if (kind === 'talent_pool') {
      return 'talentPool';
    } else {
      return 'showAll';
    }
  }
}
